import { Space, Select, Input, Button, Checkbox, Tooltip, Dropdown } from "antd";
import i18next from "i18next";
import { forwardRef, useEffect, useState } from "react";

import { CloseOutlined, SettingOutlined } from "@ant-design/icons";


import uniqueValues from "@arcgis/core/smartMapping/statistics/uniqueValues";

import { useFeatureLayer } from "../../../../hooks/useFeatureLayer";





const QueryFilter = ({ id, mapDiv, mapView, columnaProp, queryParamProp, mapLayer, sublayer, columnValues, modifyQuery, removeQuery, featureTable }) => {

    const { featureLayerCustom, crearFeatureLayerCustom, setFeatureLayerCustom } = useFeatureLayer();

    //estas son las opciones que existen para hacer la query
    const queries = ['es', 'no es', 'comienza por', 'termina en', 'contiene', 'no contiene', 'está vacío', 'no está vacío'];

    //Columnas tipo fecha
    const [columnas_tipo_fecha, setColumnas_tipo_fecha] = useState([]);

    //Objeto que vincula el texto del desplegable 2 con su correspondiente operador
    const queriesObject = {
        "es": "IN (value)",
        "no es": "NOT IN (value)",
        "comienza por": "IN (value)",
        "termina en": "IN (value)",
        "contiene": "IN (value)",
        "no contiene": "NOT IN (value)",
        "está vacío": "IS NULL",
        "no está vacío": "IS NOT NULL"
    };

    //estos deben ser los nombres de las columnas de la tabla que aparecen en el desplegable
    const [nombresColumnas, setNombresColumnas] = useState(columnValues);

    //estado por defecto del desplegable 1
    const [columnaParam, setColumnaParam] = useState(columnValues[0].name);

    //estado por defecto del desplegable 2
    const [queryParam, setQueryParam] = useState(queries[0]);

    //contenido del text input
    const [textInputParam, setTextinput] = useState([]);

    //estado del selector
    const [typeDataSelected, setTypeDataSelected] = useState('unico')

    //Valor único seleccionado
    const [valoresUnicos, setValoresUnicos] = useState([]);

    //Data del desplegable que se activa clicando en el engranaje
    const [items, setItems] = useState([
        {
            label: "Valor",
            key: 'valor',
            disabled: false
        },
        {
            label: "Único",
            key: 'unico',
            disabled: false
        },
    ]);

    /**
     * Funcion para annadir el valor seleccionado en el desplegable 1
     * @param {*} param 
     */
    const handleColumnParam = (param) => {
        setColumnaParam(param)
    };

    /**
     * Funcion para annadir el valor seleccionado en el desplegable 2.
     * También desabilidta la selección de la opción único en el desplegable 3 cuando se selecciona una query distinta de 'es' y 'no es'
     * @param {*} param 
     */
    const handleQueryParam = (param) => {
        if (['es', 'no es'].includes(param)) {

            let copyItems = [...items]
            copyItems.map((item) => item.key == 'unico' ? item.disabled = false : item.disabled = false)
            //console.log('copyItems',copyItems)
            setItems(copyItems)
            setTypeDataSelected('unico')
        } else {
            let copyItems = [...items]
            copyItems.map((item) => item.key == 'unico' ? item.disabled = true : item.disabled = false)
            //console.log('copyItems',copyItems)
            setItems(copyItems)
            setTypeDataSelected('valor')
        }
        setQueryParam(param)
    }

    /**
     * Funcion para controlar el input text
     * @param {*} param 
     */
    const handleTextInputParam = (param) => {
        const valoresUnicosCopy = [...valoresUnicos]
        //console.log('valoresUnicos', valoresUnicos)
        let result = [];
        switch (queryParam) {
            case 'es':
            case 'no es':
                result = valoresUnicosCopy.filter(item => item.label == param ? item : '').map(item => item.value)
                setTextinput(result)
                break;

            case 'comienza por':
                result = valoresUnicosCopy.filter(item => item.label.startsWith(param) ? item : '').map(item => item.value)
                setTextinput(result)
                break;

            case 'termina en':
                const numLetters = param.length
                result = valoresUnicosCopy.filter(item => item.label.slice(-numLetters) == param ? item : '').map(item => item.value)
                setTextinput(result)
                break;

            case 'contiene':
            case 'no contiene':
                result = valoresUnicosCopy.filter(item => item.label.includes(param) ? item : '').map(item => item.value)
                setTextinput(result)
                break;

            default:
                setTextinput(result)
                break;
        }
        //console.log('valoresUnicos', valoresUnicos)
    }

    /*
    Solo permite la selección de las opciones 'valor' o 'unico' en la query con 'es' y 'no es'.
    */
    const handleDropdownItemClick = (e) => {
        ['es', 'no es'].includes(queryParam) ? setTypeDataSelected(e.key) : setTypeDataSelected('valor')
    };

    /**
     * Se usa para crear el contenido WHERE de la consulta
     * @returns 
     */
    const createContentQuery = () => {
        //se obtiene el operador
        let whereClause = queriesObject[queryParam];
        //console.log('textinput', textInputParam)

        //Es necesario que los valores que van detro de la query estén entre comillas
        let content = `${columnaParam} ${textInputParam.length == 0
            ? whereClause
            : columnas_tipo_fecha.includes(columnaParam)
                ? whereClause.replace('value', "DATE '" + textInputParam.join("', DATE '") + "'")
                : whereClause.replace('value', "'" + textInputParam.join("','") + "'")}`
        //console.log('query', content)
        return content;
    }


    /**
     * Funcion para obtener los valores unicos de las columnas de la tabla
     * 
     * Comprobar si la columna tiene dominio
     *      Sí tiene: entonces se obtienen los coded values y se introducen como valores unicos
     *      No tiene: entonces se comprueba si existen subdominios
     *          Sí tiene: entonces se obtiene los coded values únicos y se introducen como valores unicos
     *          No tiene: entonces se aplica la función uniqueValues() sobre ese campo de la feature layer, 
     *          se obtienen los valores unicos y se entroducen como valores unicos
     * 
     * annadirCodedValues es una funcion complementaria a la funcion getValoresUnicos
     * 
     * parseadorDate es una funcion complementaria que convierte los datos de tipo DATE de milisecond a DATE para que
     * puedan ser interpretados por la query correctamente
     * 
     * @param {*} featureLayer 
     */

    function annadirCodedValues(codedValues) {
        let valores = [];
        codedValues.forEach(function (codedValue) {
            //console.log(codedValue.code, ":", codedValue.name);
            valores.push({
                value: String(codedValue.code),
                label: String(codedValue.name)
            })
        });
        return valores;
    }

    function parseadorDate(param) {
        let value = param.value;
        let dateMS = Number(value);
        let fecha = '';
        let fechaValue = ''
        let fechaLabel = ''
        if (value == null) {
            console.log('no hay fecha')
            return { value: null, label: null }
        } else {
            if (!isNaN(dateMS)) {
                fecha = new Date(dateMS)
                fechaValue = fecha.getFullYear() + '-' + (+fecha.getMonth() + 1) + '-' + fecha.getDate()
                fechaLabel = fecha.toLocaleDateString()
                //console.log('miliseconds', value)
                //console.log('valor fecha es', fechaValue)
                //console.log('label fecha es', fechaLabel)
                return { value: fechaValue, label: fechaLabel }
            } else {
                //console.log('miliseconds', value)
                //console.log('indefinido', value)
                return { value: "", label: null }
            }
        }
    }
    const getValoresUnicos = (featureLayer) => {
        //console.log('column', columnaParam)

        //Comprobar si tiene dominio
        let fieldName = columnaParam;
        let domain = featureLayer.getFieldDomain(fieldName);

        if (domain) {
            let codedValues = domain.codedValues;
            let valores = annadirCodedValues(codedValues)
            let valoresParseados = valores.map(valor => columnas_tipo_fecha.includes(columnaParam) ? parseadorDate(valor) : valor)
            setValoresUnicos(valoresParseados)
        } else {
            //console.log('no tiene domain')
            let codedValues = []
            if (featureLayer.types) {
                const types = featureLayer.types

                types.forEach(function (type) {
                    if (type.domains[columnaParam]) {
                        codedValues.push(...type.domains[columnaParam].codedValues)
                    }
                })
            }

            if (codedValues.length > 0) {
                let valores = annadirCodedValues(codedValues)

                const key = 'value';
                const uniqueValues = [...new Map(valores.map(item => [item[key], item])).values()];
                let valoresParseados = uniqueValues.map(valor => columnas_tipo_fecha.includes(columnaParam) ? parseadorDate(valor) : valor)
                setValoresUnicos(valoresParseados)
            } else {
                uniqueValues({
                    layer: featureLayer,
                    field: columnaParam
                }).then(function (response) {
                    let infos = response.uniqueValueInfos;
                    let valores = [];
                    infos.forEach(function (info, index) {
                        //console.log('valores', info)
                        valores.push({
                            value: String(info.value),
                            label: String(info.value)
                        })
                    });
                    let valoresParseados = valores.map(valor => columnas_tipo_fecha.includes(columnaParam) ? parseadorDate(valor) : valor)
                    //console.log('parseados', valoresParseados)
                    setValoresUnicos(valoresParseados)
                });
            }
        }
    }

    const onChangeCopitalSensible = (e) => {
        console.log(`checked = ${e.target.checked}`);
      };

    const identifyColumnTypeFecha = (featureLayer) => {
        const parsearFecha = featureLayer.fields.filter(field => field.type == 'date')
        let arrayCopy = []
        parsearFecha.forEach(function (item) {
            arrayCopy.push(item.name)
        })
        setColumnas_tipo_fecha(arrayCopy)
    }

    useEffect(() => {
        if (featureTable.layer) {
            identifyColumnTypeFecha(featureTable.layer)
        }

    },[]);


    useEffect(() => {
        //console.log('segundo use effect')
        if (featureTable.layer) {

            getValoresUnicos(featureTable.layer)
            let content = createContentQuery();
            modifyQuery(id, columnaParam, content);
        }

    }, [columnaParam, queryParam, textInputParam, featureLayerCustom]);

    return (
        <Space direction="vertical">
            <Space>
                <Select
                    defaultValue={columnaParam}
                    style={{ width: 120 }}
                    onChange={(e) => { handleColumnParam(e) }}
                    options={nombresColumnas.map((columna) => ({ label: columna.alias, value: columna.name }))}
                />
                <Select
                    defaultValue={queryParam}
                    style={{ width: 120 }}
                    onChange={(e) => { handleQueryParam(e) }}
                    options={queries.map((query) => ({ label: query, value: query }))}
                />
                {
                    ['está vacío', 'no está vacío'].includes(queryParam) ? <div></div> :
                        <>
                            {typeDataSelected == 'valor' && <Input placeholder={`${textInputParam}`} style={{ width: 200 }}
                                onChange={(e) => { handleTextInputParam(e.target.value) }} />}
                            {typeDataSelected == 'unico' && <Select
                                showSearch
                                style={{ width: 200 }}
                                placeholder=""
                                optionFilterProp="children"
                                onChange={(input, option) => handleTextInputParam(option.label)}
                                filterOption={(input, option) => (String(option?.label) ?? '').startsWith(input)}
                                filterSort={(optionA, optionB) =>
                                    (String(optionA?.label) ?? '').toLowerCase().localeCompare((String(optionB?.label) ?? '').toLowerCase())
                                }
                                options={valoresUnicos}
                            />}

                            <Dropdown menu={{
                                items,
                                selectable: true,
                                defaultSelectedKeys: [typeDataSelected],
                                onClick: handleDropdownItemClick
                            }} trigger={['click']}>
                                <a>
                                    <Space>
                                        <Tooltip title={i18next.t('common.tools.table.input_type')} >
                                            <SettingOutlined />
                                        </Tooltip>
                                    </Space>
                                </a>
                            </Dropdown>
                        </>

                }
                <Tooltip title={i18next.t('common.tools.table.delete_query')}>
                    <Button onClick={(e) => { removeQuery(id) }}>
                        <CloseOutlined />
                    </Button>
                </Tooltip>
            </Space>
            {
                ['está vacío', 'no está vacío', 'es', 'no es'].includes(queryParam) ? <div></div> :
                //<Checkbox onChange={onChangeCopitalSensible}>Distinción entre mayúsculas y minúsculas</Checkbox>
                <p>Mayúsculas y minúsculas deben coincidir.</p>
            }
        </Space>
    );
};

export default QueryFilter;